


























import { defineComponent, computed, PropType } from '@vue/composition-api';
import { NormalCreativeList, SplitTestFormData, SplitTestType } from '@tt4b/ttam-enums';
import { useSplitTestTypeDisabled } from '@tt4b/ttam-hooks';
import { getSplitTestOptions } from '../hooks';

const name = 'ttam-split-test-variable';

// import { useSplitTestTool } from '@/hooks/creation/splittest/use-split-test-tool';
// import { useSplitTestSetting } from '../use-split-test-settings';
export default defineComponent({
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    creativeBatchFormData: {
      type: Object as PropType<NormalCreativeList>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    // const { _abTestType, disableSplitTestVariable } = useSplitTestSetting();
    // const { splitTestOptions } = useSplitTestTool();
    const normalCreative = computed(() => props.creativeBatchFormData[props.creativeBatchFormData.length - 1]);

    const splitTestOptions = getSplitTestOptions();
    const { isSplitTestTypeDisabled } = useSplitTestTypeDisabled({ normalCreative });

    const abTestType = computed({
      get() {
        return props.splitTestFormData.abTestType;
      },
      set(val: SplitTestType) {
        emit('change', val);
      },
    });

    return {
      name,
      abTestType,
      splitTestOptions,
      normalCreative,
      isSplitTestTypeDisabled,
    };
  },
});
